import React, { PureComponent } from "react";
import _ from "lodash";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import "./styles.css";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import XLSX from "xlsx";
import { MDBDataTable } from "mdbreact";
import * as FileSaver from "file-saver";
import API from "../../../Common/api";
import "./styles.css";
import LoadingOverlay from "react-loading-overlay";
import styled, { ThemeProvider, css } from "styled-components";
import DatePicker from "react-datepicker";
import Overlay from '../../../Common/overlay';
import EmptyDataIcon from '../../../../images/empty_data_icon.png'
import DownloadIcon from '../../../../images/download_icon.svg'

const DarkBackground = styled.div`
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */

  ${(props) =>
    props.disappear &&
    css`
      display: block; /* show */
    `}
`;

var url = window.location.hostname;
var port = window.location.port;
var From_Date_val;
var to_Date_val;

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xls";

const exportToCSV = (csvData, fileName) => {
  // const ws = XLSX.utils.json_to_sheet(csvData);
  const Heading = [["Warehouse","Brand","Product Code","Product Desc","MRP","Order Qty","Available Qty","Pending Receiving Qty","Pending Putaway Qty"]];
  const ws = XLSX.utils.json_to_sheet(csvData, {
    origin: "A2",
    skipHeader: true,
  });
  XLSX.utils.sheet_add_aoa(ws, Heading, { origin: "A1" });
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xls", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.fetchOrderData = this.fetchOrderData.bind(this);
    this.indexOfExt = this.indexOfExt.bind(this);
    this.processData = this.processData.bind(this);

    this.state = {
      loading_overlay: false,
      showPassword: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      fileNameVal: "masterFile",
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      ErrorRowData: [],
      loading: false,
      invoice_no: "",
      trip_id: "",
      isLoading: true,
      showFetchBinData: true,
      show_process_data: true,
      from_date: "",
      to_date: "",
      tableRows: [],
      value: "",
      error: "",
      value: "select",
      selectedFileType: "",
      orderData: [],
      sto_no: "",
      filtered_orderData : [],
    };
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  componentDidMount() {
    // this.fetchInventoryData();
  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (
      window.location.port == 8098 ||
      window.location.port === ":8098"
    ) {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie("token");
    var location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: location,
    });

    localStorage.setItem("userName", username);
  }

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
    document.cookie =
      cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  indexOfExt(list, item) {
    var len = list.length;

    for (var i = 0; i < len; i++) {
      var keys = Object.keys(list[i]);
      var flg = true;
      for (var j = 0; j < keys.length; j++) {
        var value = list[i][keys[j]];
        if (item[keys[j]] !== value) {
          flg = false;
        }
      }
      if (flg == true) {
        return i;
      }
    }
    return -1;
  }

  convertDate = (inputFormat) => {
    function pad(s) {
      return s < 10 ? "0" + s : s;
    }
    var d = new Date(inputFormat);
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join("-");
  };

  FromDateChange = (date) => {
    this.setState({
      from_date: date,
      showFromErr: false,
    });
    if (date) {
      From_Date_val = this.convertDate(date);
    } else {
      this.setState({
        fromdate: "",
      });
      From_Date_val = "";
    }
  };

  ToDateChange = (date) => {
    this.setState({
      to_date: date,
      showToErr: false,
    });
    if (date) {
      to_Date_val = this.convertDate(date);
    } else {
      this.setState({
        to_date: "",
      });
      to_Date_val = "";
    }
  };

  onStoChange = (evt) => {
    this.setState({
      sto_no: evt.target.value,
    });
  };

  fetchOrderData() {
    this.setState({
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      showFetchTesterData: false,
      loading_overlay: true,
    });

    const payload = {
      // fromdate: From_Date_val,
      // todate: to_Date_val,
    };
    API.post("/reports/PendingOrderVsAvailableQty", { param: payload })
      .then((response) => response.data)

      .then((data) => {
        console.log(data);

        this.setState({ tableRows: this.assemblePosts(data.data) });
      })

      .then(async () => {
        this.setState({ isLoading: false, loading_overlay: false });
      });
  }

  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.orderData });
    } else {

      var value = this.state.orderData.filter(
        (val) => {
          return Object.keys(val).some(key => {
            var data = ""
            if (val[key] == null) {
              data = ""
            }
            else {
              data = val[key]
            }

            return data.toString().toLowerCase().includes(evt.toLowerCase())
          })
        }
      );

      this.setState({
        filtered_orderData: value,
      });
    }
  };

  assemblePosts = (data) => {
    let posts = data.map((post,index) => {
      return {
        warehouse : post.warehouse__code,
        brand  : post.warehouse__client__code,
        product_code : post.sku7_code, 
        product_desc : post.product_desc,
        mrp : post.mrp,
        order_qty : post.total_order_qty,
        available_qty : post.total_available_qty,
        pending_receiving_qty : post.receiving_pending_qty,
        pending_putaway_qty : post.putaway_pending_qty
      };
    });

    this.setState({
      loading_overlay: false,
      posts: posts,
      orderData: posts,
      filtered_orderData: posts,
    });

    return posts;
  };

  processData() {
    this.setState({
      loading: true,
    });
  }

  render() {
    const data = {
      columns: [
        {
          label: "Warehouse",
          field: "warehouse",
          sort: "asc",
          width: 140,
        },
        {
          label: "Brand",
          field: "brand",
          sort: "asc",
          width: 140,
        },
        {
          label: "Product",
          field: "product_code",
          sort: "asc",
          width: 140,
        },
        {
          label: "Product Desc",
          field: "product_desc",
          sort: "asc",
          width: 200,
        },
        {
          label: "MRP",
          field: "mrp",
          sort: "asc",
          width: 120,
        },
        {
          label: "Order Qty",
          field: "order_qty",
          width: 120,
          sort: "asc",
        },
        {
          label: "Available Qty",
          field: "available_qty",
          sort: "asc",
          width: 120,
        },
        {
          label: "Pending Receiving Qty",
          field: "pending_receiving_qty",
          width: 120,
          sort: "asc",
        },
        {
          label: "Pending Putaway Qty",
          field: "pending_putaway_qty",
          width: 120,
          sort: "asc",
        },
      ],

      rows: this.state.tableRows,
    };
    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>
            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
          <Overlay>
            <form className="form">
             
              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
                <span className="filter_title">Filters</span>
              </div>

              <div className="filter_button_container" style={{ width: '100%', marginBottom: '0px', float: 'left' }}>
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable1 "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_view"
                    onClick={() => this.fetchOrderData()}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    View
                  </Button>

                  <Button
                    type="button"
                    className="btn btn-primary-outline"
                    style={{
                        cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                        backgroundColor: '#FFFFFF',
                        color: '#333333', // Set text color
                        display: 'flex',   // Use flexbox to align image and text
                        alignItems: 'center' // Center items vertically
                    }}
                    id="button_download"
                   onClick={(e) =>
                      exportToCSV(this.state.filtered_orderData, "PendingOrder_Vs_AvailableQty_Report")
                    }
                  >
                      <img
                          src={DownloadIcon}
                          alt="Download"
                          style={{ width: '22px' }} // Adjust size as needed
                      />
                      Download
                  </Button>
              
                </ButtonToolbar>
              </div>
            </form>
          </Overlay>
          {this.state.showFetchBinData && (
              <div>
                <div>

                <Button
                            className="btn-sm button_enable1 "
                            style={{
                              fontWeight: "normal",
                              textTransform: "capitalize",
                              borderRadius: 5,
                              backgroundColor: "#70bbfd",
                              color: "#fff",
                              padding: "5px 25px",
                              fontSize: "14px",
                            }}
                            id="button_view"
                            onClick={() => this.fetchOrderData()}
                          >
                            {this.state.loading && (
                              <i
                                className="fa fa-refresh fa-spin"
                                style={{ marginRight: "5px" }}
                              />
                            )}
                            View
                          </Button>

              </div>
            <div style={{ marginTop: '4%', paddingTop: 20, paddingBottom: 0 }}>
              {/*<hr style={{marginTop:'30px',marginBottom:'0px'}}/>*/}
              
              <div
                className="dispatchData stock_check_data"
                style={{ marginTop: -27 }}
              >
         
              <MDBDataTable
                striped
                bordered
                scrollX
                sortable={false}
                hover
                onSearch={this.filterData}
                data={data}
              // style={{ textAlign: "center" }}
              />
            </div>
            </div>
            </div>
          )}
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));